<template>
  <div>
    <activity-chinese :id="msgId" v-if="type == 'cn'"></activity-chinese>
    <activity-english :id="msgId" v-else></activity-english>
  </div>
</template>
<script>
import ActivityChinese from "./component/activityChinese.vue";
import ActivityEnglish from "./component/activityEnglish.vue";
export default {
  name: 'Activity',
  components: {
    ActivityChinese,
    ActivityEnglish
  },
  data() {
    return {
      type: "cn",
      msgId: 0
    }
  },
  created () {
    if (this.$route.params.id) {
      this.msgId = this.$route.params.id;
    }
    if (this.$route.params.language && this.$route.params.language == "english") {
      this.type = "en";
    } else {
      this.type = "cn";
    }
  }
}
</script>
<style scoped lang="scss">

</style>
